import SnFormatSelect from './snFormatSelect.container';

export default SnFormatSelect;
